// extracted by mini-css-extract-plugin
module.exports = {"productSliderTitle":"ProductSlider_productSliderTitle__KH2_B","sliderContainer":"ProductSlider_sliderContainer__5YGS5"};